import { Component, Mixins, Prop } from 'vue-property-decorator';
import DateOperations from "@/mixins/date/date-operations";
import DateCore from "@/modules/DateCore/DateCore";
import {
	IHistoryMapper,
	IHistorySplittedListSorter,
	IHistorySplittedList
} from './interface';

@Component
export default class ListSorterByDateField extends Mixins(DateOperations, DateCore) {

	@Prop({ type: Array, default: () => [] })
	readonly list!: any[]

	dateKeyInListItem: string = 'date'

	weekDayNamePrefix: string = ', '

	public splitListByDateKeysToObj(list: any[]): IHistorySplittedList {
		const sortedList: any = {};

		try {
			const nowISODate: string = this.getNowISODate();
			const prevISODate: string = this.getPrevISODate();

			list.forEach(i => {
				const keyStr: string = this.getISODateByTimestamp(i[this.dateKeyInListItem]);
				const keyNum: number = this.getNumByISODate(keyStr);

				if (sortedList[keyNum]) {
					sortedList[keyNum].list.push(i);
				} else {
					sortedList[keyNum] = {};

					sortedList[keyNum].list = [ i ];

					sortedList[keyNum].date = this.getTitleByISONowAndPrevDates(keyStr, nowISODate, prevISODate) + (
						(keyStr === nowISODate || keyStr === prevISODate)
							? ''
							: this.getWeekDayNameByISODate(keyStr, this.weekDayNamePrefix)
					);
				}
			});
		} catch (err) {
			console.warn('ListSorterByDateField->splitListByDateKeysToObj()', err);
		}

		return {
			sortedList,
			getSorterBySplittedList: (): IHistorySplittedListSorter =>
				this.getSorterBySplittedList(sortedList)
		};
	}

	public getSorterBySplittedList(sortedList: any): IHistorySplittedListSorter {
		const keys: number[] = Object.keys(sortedList) as any as number[];

		return {
			keys,
			sortKeys: (): IHistoryMapper =>
				this.getMapperBySorter(keys, sortedList)
		};
	}

	public getMapperBySorter(keys: number[], sortedList: any): IHistoryMapper {
		return {
			keys: keys.sort((a: number, b: number): number => b - a),
			mapList(): any[] {
				return this.keys
					.map(key => {
						sortedList[key].list = sortedList[key].list
							.sort((a: any, b: any): number => b.date - a.date);

						return sortedList[key];
					});
			}
		};
	}

	public sortList(list: any[]): any[] {
		try {

			return this.splitListByDateKeysToObj(list)
				.getSorterBySplittedList()
				.sortKeys()
				.mapList();

		} catch (err) {
			console.warn(err);
		}

		return [];
	}

	get sortedList(): any {
		return this.sortList(this.list);
	}

}